<div id="inspectionsLast7Days"></div>
